<app-logout-iframe [url]="url" (completedLogout)="addToCompletedGets(url)" *ngFor="let url of getUrls"></app-logout-iframe>
<ng-container *ngIf="allGetCompletedEmitter | async">
  <app-logout-iframe [url]="postUrl" (completedLogout)="addToCompletedPosts(postUrl)"  *ngFor="let postUrl of postUrls"></app-logout-iframe>
</ng-container>

